import { TWorkingTimeRestaurant } from 'models'
import moment from 'moment'

export const getDayKey = (
  date?: Date | string,
): keyof TWorkingTimeRestaurant => {
  const jsDay = moment(date || new Date()).day()
  const days: (keyof TWorkingTimeRestaurant)[] = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]
  return days[jsDay]
}
